import { Injectable } from '@angular/core';

import { Events, Platform } from 'ionic-angular';
import { Storage } from '@ionic/storage';
import {AngularFireDatabase} from "angularfire2/database";
import { ConnectivityService } from '../services/connectivity';
import * as moment from "moment";



@Injectable()
export class UiData {

    public config;
    public providers;

    constructor(
        public events: Events,
        public storage: Storage,
        public afDatabase: AngularFireDatabase,
        public connectivity: ConnectivityService,
        public platform: Platform
    ) {
        var force = false;
        force = true;
        /**
         *  Get firebase data and store it localy for few minutes
         **/
        var that = this;
        storage.get("application.config").then((value) => {
            if(that.connectivity.isOnline()) {
                if (force || !value || (value.expire && value.expire > Date.now())) {

                    var userInfos = that.afDatabase.object('/appData/config');
                    //var team = this.af.database.object('/teams/' , { preserveSnapshot: true }).take(1);
                    userInfos.valueChanges().subscribe(data => {
                        that.config = data;
                        // cache it for an hour
                        storage.set("application.config", {'expire': Date.now() + (600 * 1000), "data": data});
                    });
                }
                else {
                    that.config = value.data;
                }
            }
            else {
                that.config = value.data;
            }
        });

        storage.get("application.providers").then((value) => {
            if(that.connectivity.isOnline()) {
                if(force || !value || (value.expire && value.expire>Date.now()))
                {
                    var providers  = that.afDatabase.object('/appData/providers');
                    //var team = this.af.database.object('/teams/' , { preserveSnapshot: true }).take(1);
                    providers.valueChanges().subscribe(data => {
                        that.providers = data;
                        // cache it for an hour
                        storage.set("application.providers",{'expire':Date.now()+(600*1000),"data":data});
                    });
                }
                else
                {
                    that.providers = value.data;
                }
            }
            else {
                that.providers = value.data;
            }
        });
    }

    countryList() : any {
        return this.config.countriesList;
    };
    departmentsList() : any {
        return this.config.departmentsList;
    };
    sectorsList() : any {
        return this.providers.sectors;
    };
    jobList() : any {
        return this.providers.jobs;
    };
    diplomaLevelsList() : any {
        return this.providers.diplomaLevels;
    };
    diplomaThemesList() : any {
        return this.providers.diplomaThemes;
    };
    certificatesList() : any {
        return this.providers.certificates.certificate;
    };
    permisList() : any {
        return this.providers.certificates.permis;
    };
    languageList() : any {
        return this.config.languages;
    };
    languageLevelList() : any {
        return this.config.languagesLevels;
    };
    parametersList() : any {
        return this.config.userParameters;
    };
    getLengthRanges() : any {
        return [
                {label: '1 jour',data: 1},
                {label: '1 semaine',data: 5},
                {label: '2 semaines',data: 10},
                {label: '3 semaines',data: 15},
                {label: '1 mois',data: 20},
                {label: '2 mois',data: 40},
                {label: '3 mois',data: 60},
                {label: '4 mois',data: 80},
                {label: '6 mois',data: 120},
                {label: '9 mois',data: 180},
                {label: '1 an',data: 250},
                {label: 'durée illimité',data: 100000},
        ];
    }
    getDurationRanges() : any {
        return [
            {label: '1 semaines',data: 5},
            {label: '2 semaines',data: 10},
            {label: '1 mois',data: 20},
            {label: '3 mois',data: 60},
            {label: '6 mois',data: 120},
            {label: '1 an',data: 1},
            {label: '2 ans',data: 2},
            {label: '3 ans',data: 3},
            {label: '5 ans',data: 5},
            {label: 'durée illimité',data: 100000}
        ];
    }
    getExperienceRanges() : any {
        return [

            {label: '1 mois',data: 1},
            {label: '3 mois',data: 3},
            {label: '6 mois',data: 6},
            {label: '1 an',data: 12},
            {label: '2 ans',data: 24},
            {label: '3 ans',data: 36},
            {label: '5 ans',data: 60},
            {label: '7 ans',data: 84},
            {label: '10 ans',data: 120},
        ];
    }
    getZipcodePattern()
    {
        return "^(([0-8][0-9])|(9[0-5])|(2[ab]))[0-9]{3}$";
    }
    getDataValidationWarning()
    {
        return "Je certifie sur l'honneur que les informations fournies sont exactes.";
    }
    getContractValidationWarning()
    {
        return "Cette signature vous engage contractuellement.";
    }
    zipcodeCompletor(value,formData)
    {
        //formData.ville = value;
        return true;
    }
    dateStringFromJSTime(time_give)
    {
        var time = new Date(time_give);

        var theyear = time.getFullYear();
        var themonth = time.getMonth() + 1;
        var thetoday = time.getDate();


        return thetoday + "/" + themonth + "/" + theyear;
    }
    dateMomentFromJSTime(date)
    {
        moment.lang('fr');
        var format = moment(date);
        var string =  format.fromNow();

        return string[0].toUpperCase() + string.substring(1);
    }
    getCertificateById(id)
    {
        var list = this.certificatesList();

        for(let i = 0;i<list.length;i++)
        {
            if(list[i].id == id)return list[i];
        }
        return false;
    }
    is_feat_on(str = "")
    {
        var feats = {
            'pole_emploi_connect':true,
            'full_pdf_cv':false
        };
        if(str!="" && feats[str])return true;
        else if(str!="")return false;
        else return true;


    }
    isBrowser()
    {
        return !this.platform.is('android') && !this.platform.is('ios');
    }
    isWebVersion()
    {
        return this.platform.is('core') || this.platform.is('mobileweb');
    }
}



// WEBPACK FOOTER //
// ./src/providers/ui-data.ts